export default "__VITE_ASSET__Bdxqp48D__"